import { AnalyticsGTMSettings } from 'analytics-api';
import { AnalyticsEventData } from 'idt-analytics-api/models';

export class AnalyticsOyshoEventsTransformer {

  public static fillAnalyticsDimensions(
    settings: AnalyticsGTMSettings,
    dimensions: string[],
    eventData: AnalyticsEventData
  ): AnalyticsGTMSettings {
    let settingsGTM: AnalyticsGTMSettings = { ...settings };

    dimensions.forEach((dimension) => {
      const dimensionHelper = eventData.helpers[`${dimension}`];
      if (isDefined(dimensionHelper)) {
        settingsGTM = dimensionHelper(settings, eventData.context, eventData.componentData);
      }
    });
    return settingsGTM;
  }

}
